import { render, staticRenderFns } from "./FormChat.vue?vue&type=template&id=c94243d6&scoped=true"
import script from "./FormChat.vue?vue&type=script&lang=js"
export * from "./FormChat.vue?vue&type=script&lang=js"
import style0 from "./FormChat.vue?vue&type=style&index=0&id=c94243d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94243d6",
  null
  
)

export default component.exports